module.exports = __webpack_public_path__ + "img/202602_06.90f907c7.png";